import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import type { CheckoutFormFieldProps } from "../../CheckoutPage/CheckoutForm/CheckoutFormField";
import { useOnSubmit } from "../useOnSubmit";

export const useProcessSubmission = () => {
  const { getValues } = useFormContext<CheckoutFormFieldProps>();
  const { onSubmit } = useOnSubmit();

  return useCallback(async (): Promise<void> => {
    const data = getValues();
    await onSubmit(data);
  }, [getValues, onSubmit]);
};
